var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_vm._v("分配管理")]),_c('div',{staticClass:"page-content"},[_c('page-table',{attrs:{"showPage":false,"col":_vm.columns,"data":_vm.tableData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }